type BrandProps = {
  compact?: boolean
  className?: string
}

export function Brand({ compact = false, className = '' }: BrandProps) {
  return (
    <span className={`brand ${compact ? 'brand--compact' : ''} ${className}`.trim()} aria-label="GeniusLEAD">
      <span className="brand__genius">Genius</span>
      <span className="brand__lead">LEAD</span>
    </span>
  )
}

export function ProductWordmark({ name }: { name: string }) {
  const isGenius = name.startsWith('Genius')
  if (!isGenius) return <span className="product-wordmark">{name}</span>

  return (
    <span className="product-wordmark">
      <span>Genius</span>
      <strong>{name.replace('Genius', '')}</strong>
    </span>
  )
}
